// PeachCreme header behavior — mega menu + file-folder mobile drawer
(function(){
  // MEGA MENU (desktop)
  var triggers = document.querySelectorAll('.pc-link[data-mega]');
  var megas = {};
  document.querySelectorAll('.pc-mega').forEach(function(el){ megas[el.dataset.mega] = el; });
  var active = null, closeTimer = null;
  function openMega(key){
    clearTimeout(closeTimer);
    Object.entries(megas).forEach(function(e){ e[1].classList.toggle('open', e[0]===key); });
    triggers.forEach(function(t){ t.classList.toggle('active', t.dataset.mega===key); });
    active = key;
  }
  function closeMega(){
    closeTimer = setTimeout(function(){
      Object.values(megas).forEach(function(el){ el.classList.remove('open'); });
      triggers.forEach(function(t){ t.classList.remove('active'); });
      active = null;
    }, 180);
  }
  triggers.forEach(function(t){
    t.addEventListener('mouseenter', function(){ openMega(t.dataset.mega); });
    t.addEventListener('mouseleave', closeMega);
    t.addEventListener('click', function(e){ e.preventDefault(); if(active===t.dataset.mega){closeMega();}else{openMega(t.dataset.mega);} });
  });
  Object.values(megas).forEach(function(el){
    el.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); });
    el.addEventListener('mouseleave', closeMega);
  });

  // MOBILE OVERLAY
  var burger = document.getElementById('pcBurger');
  var over = document.getElementById('pcMobOver');
  var closeBtn = document.getElementById('pcMobClose');
  var state1 = document.getElementById('pcMobState1');
  var drawers = document.querySelectorAll('.pc-mob-drawer');
  function openMob(){ if(over){over.classList.add('open'); document.body.classList.add('pc-menu-open');} }
  function closeMob(){ if(over){over.classList.remove('open'); document.body.classList.remove('pc-menu-open'); closeAllDrawers();} }
  function closeAllDrawers(){ drawers.forEach(function(d){ d.classList.remove('open'); }); if(state1) state1.style.display=''; }
  if(burger){
    burger.addEventListener('click', openMob);
    burger.addEventListener('touchend', function(e){ e.preventDefault(); openMob(); }, {passive:false});
  }
  if(closeBtn){
    closeBtn.addEventListener('click', closeMob);
    closeBtn.addEventListener('touchend', function(e){ e.preventDefault(); closeMob(); }, {passive:false});
  }
  if(over){ over.addEventListener('click', function(e){ if(e.target===over) closeMob(); }); }
  // drill: top-level li with data-open opens a drawer
  if(state1){
    state1.querySelectorAll('li[data-open]').forEach(function(li){
      li.addEventListener('click', function(){
        state1.style.display = 'none';
        var d = document.getElementById('pcMobDrawer-' + li.dataset.open);
        if(d) d.classList.add('open');
      });
    });
  }
  // back button returns to state 1
  document.querySelectorAll('[data-back]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); closeAllDrawers(); });
  });
})();
